module.exports = __webpack_public_path__ + "static/media/ase-certified-3 (1).7dae1892.svg";